<div class="w-full h-full relative">
  <mat-progress-bar *ngIf="state.loadingLogs" mode="indeterminate" class="w-full absolute top-0 left-0 z-index-3">
  </mat-progress-bar>
  <button
    mat-icon-button
    (click)="closeDialog.emit()"
    class="absolute bg-background-primary top-[10px] right-[10px] z-index-3"
  >
    <fa-icon class="text-gray-800" [icon]="['fal', 'times']"></fa-icon>
  </button>
  <mat-sidenav-container
    [hasBackdrop]="state.isSmallScreen"
    class="w-full h-full"
    (backdropClick)="toggleSideBar(false)"
  >
    <mat-sidenav
      #sidenav
      [mode]="state.isSmallScreen ? 'over' : 'side'"
      [opened]="state.isOpened"
      [position]="'start'"
      class="sidenav-crud z-depth-1 w-[350px]"
    >
      <div class="pl-3 mt-4 text-standard-heading aligner-start">
        <fa-icon [icon]="['fal', 'history']"></fa-icon>
        <div class="ml-2 font-medium">Logs</div>
      </div>
      <div *ngIf="sideNavTemplate">
        <div class="time-box-info p-[12px]">
          <ng-container
            [ngTemplateOutlet]="sideNavTemplate.template"
            [ngTemplateOutletContext]="sideNavTemplate.context"
          ></ng-container>
        </div>
      </div>
    </mat-sidenav>
    <mat-sidenav-content class="log-display" id="logs">
      <y42-logs-ag-grid #logsAgGrid *ngIf="!state.loadingLogs" [logs]="state.logs"> </y42-logs-ag-grid>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
